<template>
  <div class="container-relatorio-filtros">
    <h3 class="primary--text text-selecione">Selecione os filtros</h3>
    <div class="container-relatorio-interno">
      <h3>Relatório pacientes atendidos</h3>
    </div>
    <div class="row-bottom">
      <v-tooltip top>
        <template v-slot:activator={on}>
          <v-btn
              v-on="on"
              id="botaoDownload"
              class="mr-5"
              icon
              @click="gerarRelatorio(true)">
            <v-icon>mdi-file-download</v-icon>
          </v-btn>
        </template>
        Baixar .PDF
      </v-tooltip>
      <v-btn
          id="botaoGerar"
          color="primary"
          depressed
          @click="gerarRelatorio(false)">
        Gerar relatório
      </v-btn>
    </div>
  </div>
</template>

<script>


export default {
    name: 'RelatorioPacienteAtendidos',
    methods: {
        async gerarRelatorio(baixar){
            console.log('gerarRelatorio: ' + baixar)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-relatorio-filtros
  width 100%

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  padding-right 20px
  text-align right

.text-selecione
  padding-top 10px
  padding-left 10px
  border-bottom 1px solid #ddd

.container-relatorio-interno
  padding 20px

</style>